import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=3885dabb&"
import script from "./setAccount.vue?vue&type=script&lang=js&"
export * from "./setAccount.vue?vue&type=script&lang=js&"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=3885dabb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports